module.exports = window["core-js/modules/esnext.string.replace-all.js"];